<template>
  <section class="learning-area">
    <v-cols>
      <v-col cols="12">
        <v-select
          class="pa-4"
          v-model="selectedAreas"
          :items="areas"
          attach
          chips
          close
          label="Learning Areas"
          multiple
        ></v-select>
      </v-col>
      <v-col cols="12" class="pl-3 pr-3" v-if="learningData">
        <bar-chart ref="barChart" :chart-data="learningData" />
      </v-col>
    </v-cols>
  </section>
</template>
<script>
import _ from 'lodash'
import BarChart from '@/components/charts/BarChart'

export default {
  name: 'LearningArea',
  components: {
    BarChart
  },
  props: {
    learningAreas: {
      type: Array,
      required: true
    }
  },
  data() {
    return {}
  },
  watch: {},
  computed: {
    areas() {
      if (!this.learningAreas) return []
      return this.learningAreas.map(c => {
        return { text: _.capitalize(c.learning_area), value: c.learning_area }
      })
    },
    selectedAreas() {
      if (!this.learningAreas) return []
      return Array.from(this.learningAreas, l => l.learning_area)
    },
    learningData() {
      let learningAreas = this.learningAreas

      let labels = []
      let correct = {
        label: 'Correct',
        stack: 1,
        backgroundColor: '#00ABD7',
        data: []
      }

      let incorrect = {
        label: 'Incorrect',
        stack: 1,
        backgroundColor: '#8AFBFF',
        data: []
      }

      if (!learningAreas) {
        labels = ['No Data']
        correct.data = [0]
        incorrect.data = [0]
        return { labels, datasets: [correct, incorrect] }
      }

      if (this.selectedAreas.length > 0) {
        learningAreas = learningAreas.filter(v =>
          this.selectedAreas.includes(v.learning_area)
        )
      }

      _.forEach(learningAreas, lesson => {
        let learning = lesson.learning_area
        labels = [...labels, [_.capitalize(learning)]]
        correct['data'] = [...correct['data'], lesson.correct]
        incorrect['data'] = [...incorrect['data'], lesson.incorrect]
      })
      return { labels, datasets: [correct, incorrect] }
    }
  },
  async mounted() {},
  methods: {
    updateChart() {
      if (this.$refs.barChart) this.$refs.barChart.updateChart()
    }
  }
}
</script>

<style lang="scss">
.learning-area {
}
</style>
